import { render } from "./WorkflowFields.vue?vue&type=template&id=53f3635e&scoped=true"
import script from "./WorkflowFields.vue?vue&type=script&lang=js"
export * from "./WorkflowFields.vue?vue&type=script&lang=js"

import "./WorkflowFields.vue?vue&type=style&index=0&id=53f3635e&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/91znxra3/0/cs/cs-manager-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f3635e"]])

export default __exports__